// Prevent input error flicker fest while typing.
export default function /* @ngInject */ debounceValue(getOptionsDebounce) {
    return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            if (ngModel) {
                ngModel.$options = ngModel.$options || getOptionsDebounce(200);
            }
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/debounce-value.js